import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DataService } from './modules/core/services/data.service';
import { HttpClientModule } from '@angular/common/http';
import { TransferHttpCacheModule } from '@nguniversal/common';
import { FadeInOnScrollModule } from './modules/directives/fade-in-on-scroll/fade-in-on-scroll.module';
import { NeighborhoodsGuideComponent } from './pages/neighborhoods-guide/neighborhoods-guide.component';
import { ChatOverlayModule } from './shared/chat-overlay/chat-overlay.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ComponentsModule } from './modules/components/components.module';

//import { NewsletterComponent } from '../app/shared/newsletter/newsletter.component';

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        // Reusa en el navegador las respuestas GET que ya pidió el SSR (evita doble pedido y parpadeo de listas).
        TransferHttpCacheModule,
        FadeInOnScrollModule,
         ReactiveFormsModule,
            CommonModule,
            FormsModule,
            ChatOverlayModule,
            ComponentsModule,

    ],
    providers: [DataService],
    bootstrap: [AppComponent],
})
export class AppModule {}
